import React from 'react';
import Footer from '../components/Footer';
import './TermsAndConditions.css';
function TermsAndConditions() {
  return <div className="page-termsandconditions">
      <div style={{
      position: 'absolute',
      width: 0,
      height: 0,
      overflow: 'hidden'
    }} aria-hidden="true">
        <>
          <svg width="121" height="38" viewBox="0 0 121 38" fill="none" id="svg-1756771329_4687">
            <path d="M51.5769 15.8841L48.7769 15.3579C46.9278 14.9895 46.5052 14.779 46.5052 13.7791C46.5052 12.7792 47.1391 12.3582 49.1995 12.3582C51.5241 12.3582 52.2109 12.8844 52.2109 14.5685V14.8316L55.6978 13.8843C55.4336 11.1478 53.4789 9.14795 49.3052 9.14795C44.7617 9.14795 43.0183 11.5161 43.0183 13.937C43.0183 16.4104 44.2863 17.8839 47.2976 18.4102L50.0977 18.8838C52.3166 19.2522 52.5807 19.6206 52.5807 20.6731C52.5807 21.7257 52.1053 22.1467 50.0448 22.1467C47.192 22.1467 46.558 21.673 46.558 19.9364V19.6732L43.0711 20.6205C43.3353 23.7255 45.5014 25.3569 49.8335 25.3569C54.3242 25.3569 56.0148 23.0939 56.0148 20.5679C56.0676 18.3049 54.9053 16.5683 51.5769 15.8841Z" fill="black" />
            <path d="M68.8003 18.1995V17.9364C68.8003 15.0419 66.4758 13.0947 63.3059 13.0947C59.3436 13.0947 57.0718 15.5155 57.0718 19.3046C57.0718 23.0411 59.1851 25.4093 63.0946 25.4093C66.3701 25.4093 68.7475 23.4621 68.7475 20.5677V20.3045H65.2078V20.4624C65.2078 21.7781 64.4682 22.2517 62.9889 22.2517C61.2983 22.2517 60.5587 21.4623 60.5587 19.252C60.5587 17.0417 61.2983 16.2523 62.9889 16.2523C64.4682 16.2523 65.2078 16.6733 65.2078 18.0416V18.2521H68.8003V18.1995Z" fill="black" />
            <path d="M75.932 13.042C72.6037 13.042 70.3848 14.8839 70.3848 17.7257V17.9889L73.7659 17.7257C73.7659 16.5153 74.3471 16.147 75.7735 16.147C77.1471 16.147 77.9396 16.4101 77.9396 17.7784V18.1468L73.8716 18.7783C71.4414 19.1467 70.1206 20.3044 70.1206 22.0937C70.1206 24.2514 71.7584 25.3566 73.8716 25.3566C76.0905 25.3566 77.2528 24.4093 77.9396 23.5146H78.0981V25.0934H81.3736V18.0941C81.268 14.9892 79.4189 13.042 75.932 13.042ZM74.9811 22.6726C73.9244 22.6726 73.449 22.4621 73.449 21.8306C73.449 21.357 73.7659 21.0938 74.5056 20.9886L77.8868 20.4623C77.8868 22.3042 76.4075 22.6726 74.9811 22.6726Z" fill="black" />
            <path d="M83.3811 10.3057V25.1463H86.9208V9.3584L83.3811 10.3057Z" fill="black" />
            <path d="M89.1398 10.3057V25.1463H92.6795V9.3584L89.1398 10.3057Z" fill="black" />
            <path d="M100.392 13.0425C104.196 13.0425 106.415 15.4633 106.415 19.1997C106.415 22.9362 104.196 25.3569 100.392 25.3569C96.5882 25.3568 94.3167 22.9361 94.3167 19.1997C94.3167 15.4634 96.5883 13.0426 100.392 13.0425ZM100.5 15.9272C98.6956 15.9272 97.2269 17.395 97.2268 19.1997C97.2268 21.0044 98.6955 22.4731 100.5 22.4731C100.769 22.4731 101.043 22.4391 101.312 22.3677C101.366 22.3551 101.417 22.3169 101.443 22.2622L101.496 22.1587C101.889 21.3991 102.557 20.8185 103.365 20.5376C103.449 20.5082 103.504 20.4325 103.504 20.3442V18.0513C103.504 17.963 103.449 17.8873 103.365 17.8579C102.557 17.5771 101.889 16.9961 101.499 16.2358L101.447 16.1333C101.421 16.0829 101.371 16.0447 101.317 16.0278C101.047 15.9605 100.774 15.9273 100.5 15.9272Z" fill="black" />
            <path d="M114.973 13.042C113.177 13.042 111.804 13.7261 111.17 15.0418H111.064V13.3051H107.788V29.093L111.328 28.1458V23.5673H111.434C111.962 24.5672 113.124 25.3566 115.026 25.3566C118.249 25.3566 120.045 22.9358 120.045 19.1993C120.098 15.4628 118.302 13.042 114.973 13.042ZM113.917 22.3569C112.226 22.3569 111.328 21.778 111.328 20.1466V18.252C111.328 16.6732 112.279 16.0417 113.917 16.0417C115.977 16.0417 116.506 17.0416 116.506 19.1993C116.506 21.357 115.977 22.3569 113.917 22.3569Z" fill="black" />
            <path d="M25.0748 5.98843C22.7229 8.41155 20.3711 10.8258 18.0192 13.2489C17.9925 13.2667 17.9747 13.2845 17.948 13.3112L12.8256 18.4336C12.3356 18.9236 12.3356 19.7343 12.8256 20.2243L17.6807 25.0794L11.7031 31.3421C10.7766 30.7096 9.89466 29.9791 9.02162 29.0972C2.75892 22.8434 2.54512 15.1108 8.85236 8.79461C13.85 3.79693 19.7475 2.95062 25.0748 5.98843Z" fill="url(#svg-1756771329_4687_paint0_linear_39_9540)" />
            <path d="M29.2796 29.2128C24.2908 34.1927 18.429 35.0836 13.1373 32.2239L15.2397 30.0235C16.8522 28.3576 18.4557 26.7006 20.0682 25.0347L21.6895 23.4134L24.8699 20.233C25.3598 19.7431 25.3598 18.9324 24.8699 18.4424L23.4089 16.9814L20.0503 13.6229L25.9656 7.43148L26.4823 6.89697C27.3553 7.51166 28.2284 8.25107 29.0569 9.07956C35.2661 15.271 35.5334 22.9501 29.2796 29.2128Z" fill="url(#svg-1756771329_4687_paint1_linear_39_9540)" />
            <defs>
              <linearGradient id="svg-1756771329_4687_paint0_linear_39_9540" x1="21.3346" y1="-5.73425" x2="-18.5026" y2="81.306" gradientUnits="userSpaceOnUse">
                <stop stopColor="#00DECA" />
                <stop offset="0.37798" stopColor="#3A8AFA" />
                <stop offset="1" stopColor="#1A6AF4" />
              </linearGradient>
              <linearGradient id="svg-1756771329_4687_paint1_linear_39_9540" x1="30.1297" y1="-2.99484" x2="-9.46262" y2="83.4647" gradientUnits="userSpaceOnUse">
                <stop stopColor="#00DECA" />
                <stop offset="0.37798" stopColor="#3A8AFA" />
                <stop offset="1" stopColor="#1A6AF4" />
              </linearGradient>
            </defs>
          </svg>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" id="svg-1839680863_948">
            <path d="M9.90033 7.61699C10.967 7.66699 11.242 8.57533 11.2587 9.00033H12.7503C12.6837 7.35033 11.5087 6.34199 9.87533 6.34199C8.03366 6.34199 6.66699 7.50033 6.66699 10.117C6.66699 11.7337 7.44199 13.6503 9.86699 13.6503C11.717 13.6503 12.7087 12.2753 12.7337 11.192H11.242C11.217 11.6837 10.867 12.342 9.88366 12.392C8.79199 12.3587 8.33366 11.5087 8.33366 10.117C8.33366 7.70866 9.40033 7.63366 9.90033 7.61699ZM10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667Z" fill="#666D80" />
          </svg>
          <svg width="699" height="196" viewBox="0 0 699 196" fill="none" id="svg-1137231340_6119">
            <path d="M668.903 75.4492C685.462 75.4492 698.806 91.3256 699 111.098C699 111.195 699 111.39 699 111.488C699 111.682 699 111.877 699 111.975C698.806 131.747 685.462 147.623 668.903 147.623C668.027 147.623 667.15 147.623 666.176 147.526L666.079 147.428C659.163 146.649 653.904 140.805 653.904 133.792V129.604H647.865V137.299V147.623V162.501L626.826 177.72V111.488V75.4492H647.865V85.7737V93.4684H653.904V89.2801C653.904 82.2673 659.163 76.3258 666.079 75.5466H666.176C667.15 75.4492 668.027 75.4492 668.903 75.4492ZM662.767 126.585C671.144 126.682 677.962 119.864 677.962 111.488C677.962 103.208 671.144 96.3904 662.767 96.4878C654.683 96.5852 647.962 103.208 647.865 111.39V111.488C647.865 111.585 647.865 111.585 647.865 111.682C647.962 119.864 654.683 126.487 662.767 126.585Z" fill="#030319" />
            <path d="M583.064 75.4492C602.933 75.4492 619.102 91.6177 619.102 111.488C619.102 131.455 602.933 147.623 583.064 147.623C563.096 147.623 546.928 131.455 546.928 111.488C546.928 91.6177 563.096 75.4492 583.064 75.4492ZM583.064 126.585C591.343 126.585 598.063 119.864 598.063 111.488C598.063 103.208 591.343 96.4878 583.064 96.4878C574.687 96.4878 567.966 103.208 567.966 111.488C567.966 119.864 574.687 126.585 583.064 126.585Z" fill="#030319" />
            <path d="M488.334 147.623V60.5712L509.373 45.3523V147.623H488.334ZM518.431 147.623V58.9032L539.47 43.6843V147.623H518.431Z" fill="#030319" />
            <path d="M459.569 85.7737V75.4492H480.608V111.488V147.623H459.569V137.299V129.604H453.53V133.792C453.53 140.805 448.368 146.649 441.355 147.428H441.258C440.381 147.526 439.407 147.623 438.531 147.623C422.07 147.623 408.628 131.747 408.434 111.975C408.434 111.78 408.434 111.682 408.434 111.488C408.434 111.39 408.434 111.195 408.434 111C408.628 91.3255 422.07 75.4492 438.531 75.4492C439.407 75.4492 440.381 75.4492 441.258 75.5466H441.355C448.368 76.3258 453.53 82.2673 453.53 89.2801V93.4684H459.569V85.7737ZM459.569 111.682C459.569 111.585 459.569 111.585 459.569 111.488V111.39C459.472 103.208 452.848 96.5852 444.667 96.4878C436.29 96.3904 429.472 103.208 429.472 111.488C429.472 119.864 436.29 126.585 444.667 126.585C452.848 126.487 459.472 119.767 459.569 111.682Z" fill="#030319" />
            <path d="M365.433 96.4878C357.056 96.4878 350.336 103.208 350.336 111.488C350.336 119.864 357.056 126.585 365.433 126.585C371.569 126.585 376.926 122.883 379.166 117.526H400.984C398.159 134.571 383.257 147.623 365.433 147.623C345.465 147.623 329.297 131.455 329.297 111.488C329.297 91.6177 345.465 75.4492 365.433 75.4492C383.257 75.4492 398.159 88.4035 400.984 105.546H379.166C376.926 100.189 371.569 96.4878 365.433 96.4878Z" fill="#030319" />
            <path d="M281.603 66.6326C266.839 66.6326 260.844 71.4881 260.844 77.8003C260.844 89.745 321.687 81.7819 321.687 115.479C321.687 120.335 315.245 147.623 278.739 147.623C254.492 147.623 244.023 133.833 239.37 127.715L238.744 126.938L254.724 115.283C254.724 115.283 262.365 126.647 278.739 126.647C293.592 126.647 299.587 121.792 299.587 115.479C299.587 103.243 238.744 111.692 238.744 77.8003C238.744 72.9448 245.186 45.6566 281.603 45.6566C305.94 45.6566 316.408 59.4464 321.061 65.5644L321.687 66.3412L305.707 77.6162C305.707 77.6162 298.066 66.6326 281.603 66.6326Z" fill="#030319" />
            <ellipse cx="97.8957" cy="97.8954" rx="97.8957" ry="97.8954" fill="url(#svg-1137231340_6119_paint0_linear_1843_2573)" />
            <path d="M103.576 14.4118C115.249 13.8539 129.142 17.6986 139.282 23.2509C158.722 33.8511 173.055 51.8528 179.03 73.1714C184.904 94.1022 182.275 116.505 171.709 135.505C161.278 154.663 143.583 168.825 122.604 174.805C121.916 175 121.535 175.131 120.923 174.79C120.848 174.232 123.053 171.981 123.588 171.354C127.648 166.588 129.697 162.178 131.673 156.382C133.304 155.423 134.869 154.356 136.358 153.19C151.792 141.054 161.837 123.339 164.329 103.867C166.932 83.664 161.768 65.3031 149.385 49.2548C145.6 44.5826 141.241 40.4056 136.412 36.8219C127.789 30.443 117.883 26.3644 107.081 25.9036C100.34 25.6159 94.1717 26.5885 89.9416 32.5503C88.1358 35.1174 87.0577 38.1249 86.8214 41.2544C85.8581 52.6598 94.7935 61.1826 102.438 68.3351C106.731 72.3277 111.304 76.1609 115.634 80.1021C126.117 89.6427 137.49 100.106 139.627 114.873C140.71 122.355 139.833 129.826 137.214 136.929C136.785 138.093 136.144 140.229 135.444 141.211L135.214 141.233C134.907 140.566 134.342 137.129 134.064 136.042C133.36 133.295 132.371 130.526 131.084 127.972C123.12 112.161 107.759 101.092 95.0915 89.0304C83.0497 77.5651 70.841 66.3252 69.8719 48.4363C69.4109 39.9256 72.4487 31.2566 78.2811 25.0667C85.079 17.8519 93.8037 14.7104 103.576 14.4118Z" fill="white" />
            <path d="M91.5742 180.82C79.901 181.378 66.0082 177.534 55.8688 171.981C36.4285 161.381 22.0955 143.379 16.1206 122.061C10.246 101.13 12.8756 78.7274 23.4413 59.7273C33.8727 40.5694 51.5673 26.4075 72.5462 20.4273C73.234 20.2325 73.6158 20.1012 74.2273 20.442C74.3028 20.9998 72.097 23.2514 71.5628 23.8785C67.5026 28.6444 65.4533 33.0547 63.4777 38.8504C61.8468 39.8095 60.2815 40.8763 58.7919 42.042C43.3582 54.178 33.3134 71.8929 30.8211 91.3651C28.218 111.568 33.3828 129.929 45.765 145.977C49.5501 150.65 53.9092 154.827 58.7385 158.41C67.3615 164.789 77.2674 168.868 88.0694 169.329C94.8106 169.616 100.979 168.644 105.209 162.682C107.015 160.115 108.093 157.107 108.329 153.978C109.292 142.572 100.357 134.05 92.7125 126.897C88.4197 122.904 83.8462 119.071 79.5159 115.13C69.0339 105.589 57.6601 95.1262 55.5235 80.3593C54.4404 72.877 55.3169 65.4066 57.9365 58.3035C58.3658 57.1393 59.0062 55.0028 59.7064 54.0216L59.9363 53.9994C60.2437 54.6664 60.8081 58.1028 61.0866 59.1903C61.7902 61.9377 62.7798 64.7057 64.0662 67.2598C72.0303 83.0713 87.391 94.1406 100.059 106.202C112.101 117.667 124.309 128.907 125.278 146.796C125.739 155.307 122.702 163.976 116.869 170.165C110.071 177.38 101.347 180.522 91.5742 180.82Z" fill="white" />
            <defs>
              <linearGradient id="svg-1137231340_6119_paint0_linear_1843_2573" x1="97.8957" y1="0" x2="46.0375" y2="179.202" gradientUnits="userSpaceOnUse">
                <stop stopColor="#0F1AF1" />
                <stop offset="1" stopColor="#2E38F9" />
              </linearGradient>
            </defs>
          </svg>
        </>
      </div>
      <>
        {/*$*/}
        <div data-framer-root="" className="framer-jKLcB framer-6lXp4 framer-166efju termsandconditions-s1">
          <div className="ssr-variant hidden-1g04cjv">
            <div className="framer-12ghrqh-container hidden-166efju termsandconditions-s2" data-framer-appear-id="12ghrqh">
              <div className="framer-8MFL4 framer-15zawlh framer-v-15zawlh termsandconditions-s3" data-framer-name="Desktop [Default Boxed]">
                <header className="framer-ooxjtq termsandconditions-s4" data-border="true" data-framer-name="Main Area">
                  <div className="framer-p578i7 termsandconditions-s5" data-framer-name="Background [Default]" />
                  <div className="framer-pc27k4 termsandconditions-s6" data-framer-name="Background [Boxed Mini]" />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1hjthz termsandconditions-s7" aria-hidden="true" />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div className="framer-1hg3ikx-container" data-framer-name="Menu [Desktop]" name="Menu [Desktop]">
                        <div name="Menu [Desktop]" className="framer-n0D3w framer-1itjusz framer-v-1itjusz termsandconditions-s8" data-framer-name="Menu">
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq termsandconditions-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/accounts" tabIndex={0}>
                              <div className="framer-19g30xi termsandconditions-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text termsandconditions-s11">
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq termsandconditions-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-pay" tabIndex={0}>
                              <div className="framer-19g30xi termsandconditions-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text termsandconditions-s11">
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq termsandconditions-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/cards" tabIndex={0}>
                              <div className="framer-19g30xi termsandconditions-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text termsandconditions-s11">
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq termsandconditions-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-plus" tabIndex={0}>
                              <div className="framer-19g30xi termsandconditions-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text termsandconditions-s11">
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq termsandconditions-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/helpcenter" tabIndex={0}>
                              <div className="framer-19g30xi termsandconditions-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text termsandconditions-s11">
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                      <div className="framer-16051d2" data-framer-name="QR Overlay Trigger" data-highlight="true" tabIndex={0}>
                        <div className="framer-168591e-container">
                          <div className="framer-wWHmH framer-ly6l8a framer-v-18roq29 termsandconditions-s12" data-border="true" data-framer-name="Variant 2" data-highlight="true" tabIndex={0}>
                            <div className="framer-1ebu3nm termsandconditions-s13 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text termsandconditions-s14">
                                Get Started
                              </p>
                            </div>
                            <div className="framer-1u4w7ze termsandconditions-s15 reveal" data-framer-component-type="RichTextContainer">
                              <p className="framer-text termsandconditions-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-166efju">
            <div className="framer-12ghrqh-container hidden-166efju" data-framer-appear-id="12ghrqh">
              <div className="framer-8MFL4 framer-15zawlh framer-v-ewbo4l termsandconditions-s3" data-framer-name="Mobile">
                <header className="framer-ooxjtq termsandconditions-s17" data-border="true" data-framer-name="Main Area">
                  <div className="framer-p578i7 termsandconditions-s5" data-framer-name="Background [Default]" />
                  <div className="framer-pc27k4 termsandconditions-s6" data-framer-name="Background [Boxed Mini]" />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1hjthz termsandconditions-s7" aria-hidden="true" />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav" />
                    <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                      <div className="framer-1yr51k6-container">
                        {/*$*/}
                        <div className="framer-OuhX3 framer-1ib4qbi framer-v-1ib4qbi termsandconditions-s18" data-framer-name="Mobile Menu" data-highlight="true" tabIndex={0}>
                          <div className="framer-1cux5of termsandconditions-s19" />
                          <div className="framer-1w1bul6 termsandconditions-s19" />
                          <div className="framer-1ku2ucf termsandconditions-s20" />
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="framer-1bwj7c3-container hidden-1g04cjv termsandconditions-s2" data-framer-appear-id="1bwj7c3" id="1bwj7c3">
            <div className="framer-8MFL4 framer-15zawlh framer-v-15zawlh termsandconditions-s3" data-framer-name="Desktop [Default Boxed]">
              <header className="framer-ooxjtq termsandconditions-s4" data-border="true" data-framer-name="Main Area">
                <div className="framer-p578i7 termsandconditions-s5" data-framer-name="Background [Default]" />
                <div className="framer-pc27k4 termsandconditions-s6" data-framer-name="Background [Boxed Mini]" />
                <div className="framer-cjwofg" data-framer-name="Content">
                  {/*$*/}
                  <a className="framer-1jy87r1 framer-145ct8v" href="/">
                    <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1hjthz termsandconditions-s7" aria-hidden="true" />
                  </a>
                  {/*/$*/}
                  <nav className="framer-xe9vp0" data-framer-name="Nav">
                    <div className="framer-1hg3ikx-container" data-framer-name="Menu [Desktop]" name="Menu [Desktop]">
                      <div name="Menu [Desktop]" className="framer-n0D3w framer-1itjusz framer-v-1itjusz termsandconditions-s8" data-framer-name="Menu">
                        {/*$*/}
                        <div className="framer-mquu2a-container">
                          {/*$*/}
                          <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq termsandconditions-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/accounts" tabIndex={0}>
                            <div className="framer-19g30xi termsandconditions-s10 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text termsandconditions-s11">
                                Accounts{' '}
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-1yixouk-container">
                          {/*$*/}
                          <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq termsandconditions-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-pay" tabIndex={0}>
                            <div className="framer-19g30xi termsandconditions-s10 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text termsandconditions-s11">
                                Scallop Pay
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-wi7xty-container">
                          {/*$*/}
                          <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq termsandconditions-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/cards" tabIndex={0}>
                            <div className="framer-19g30xi termsandconditions-s10 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text termsandconditions-s11">
                                Cards
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-1tpzm7c-container">
                          {/*$*/}
                          <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq termsandconditions-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-plus" tabIndex={0}>
                            <div className="framer-19g30xi termsandconditions-s10 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text termsandconditions-s11">
                                Scallop+
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-u2qi4r-container">
                          {/*$*/}
                          <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq termsandconditions-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/helpcenter" tabIndex={0}>
                            <div className="framer-19g30xi termsandconditions-s10 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text termsandconditions-s11">
                                FAQs
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </nav>
                  <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                    <div className="framer-16051d2" data-framer-name="QR Overlay Trigger" data-highlight="true" tabIndex={0}>
                      <div className="framer-168591e-container">
                        <div className="framer-wWHmH framer-ly6l8a framer-v-18roq29 termsandconditions-s12" data-border="true" data-framer-name="Variant 2" data-highlight="true" tabIndex={0}>
                          <div className="framer-1ebu3nm termsandconditions-s13 reveal" data-framer-component-type="RichTextContainer">
                            <p dir="auto" className="framer-text termsandconditions-s14">
                              Get Started
                            </p>
                          </div>
                          <div className="framer-1u4w7ze termsandconditions-s15 reveal" data-framer-component-type="RichTextContainer">
                            <p className="framer-text termsandconditions-s16">
                              Coming soon
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </header>
            </div>
          </div>
          <div className="framer-1n7dh55" data-framer-name="Hero" id="hero">
            <div className="framer-4q47hb" data-framer-name="Section">
              <div className="framer-bbag0q" data-framer-name="Container">
                <div className="framer-bzhznr" data-framer-name="Content">
                  <div className="framer-1122b77 termsandconditions-s21 reveal" data-framer-name="Date" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s22">
                      Last update: Feb 2026
                    </p>
                  </div>
                  <div className="framer-1bmafnp" data-framer-name="Container">
                    <div className="ssr-variant hidden-1g04cjv">
                      <div className="framer-1lk5wk9 termsandconditions-s21 reveal" data-framer-name="Empowering your business for tomorrow." data-framer-component-type="RichTextContainer">
                        <h1 className="framer-text termsandconditions-s23">
                          Term &amp; Conditions
                        </h1>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-166efju">
                      <div className="framer-1lk5wk9 termsandconditions-s21 reveal" data-framer-name="Empowering your business for tomorrow." data-framer-component-type="RichTextContainer">
                        <h1 dir="auto" className="framer-text termsandconditions-s24">
                          Term &amp; Conditions
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-13wgvyc" data-framer-name="Text">
            <div className="framer-1fpo3pa" data-framer-name="Section">
              <div className="framer-1v5f7sf" data-framer-name="Content">
                <div className="framer-1jvb6lh" data-framer-name="Container">
                  <div className="framer-1xdtd1y hidden-1g04cjv termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                    <h2 dir="auto" className="framer-text termsandconditions-s25">
                      IMPORTANT NOTICE
                    </h2>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-bh5l89 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        Please read carefully
                        <br className="framer-text" />
                        In these Terms and Conditions, &ldquo;Scallop&rdquo;,
                        &ldquo;we&rdquo;, &ldquo;us&rdquo; and &ldquo;our&rdquo;
                        refer to the{' '}
                        <span className="framer-text termsandconditions-s27">
                          <strong className="framer-text">Scallop Group</strong>
                        </span>
                        , acting through the relevant entity involved in the
                        provision, operation, or support of the services.
                        <br className="framer-text" />
                        <br className="framer-text" />
                        By accessing or using the{' '}
                        <span className="framer-text termsandconditions-s27">
                          <strong className="framer-text">
                            Scallop Platform
                          </strong>
                        </span>
                        , you are entering into a legally binding agreement with
                        the{' '}
                        <span className="framer-text termsandconditions-s27">
                          <strong className="framer-text">Scallop Group</strong>
                        </span>
                        , acting through the relevant entity involved in the
                        provision, operation, or support of the services. These
                        Terms and Conditions explain how the Platform operates,
                        how services are made available, and the rights and
                        responsibilities that apply to you. Certain services or
                        features may be subject to additional or separate terms.
                        Where applicable, such terms will be made available to
                        you and shall form part of your agreement. These Terms
                        and Conditions and any additional terms should be read
                        together. Scallop does not provide legal, tax,
                        financial, or investment advice. Any information made
                        available through the Platform or related materials is
                        provided for general information purposes only. You are
                        solely responsible for determining whether the services
                        are suitable for you and for understanding the
                        contractual and regulatory framework applicable to your
                        use of the Platform. You should consider obtaining
                        independent professional advice where appropriate and
                        should only proceed if you are comfortable with the
                        risks, obligations, and terms that apply. By accessing
                        or using the Platform, you confirm that you have read,
                        understood, and agree to be bound by these Terms and
                        Conditions. If you do not agree, you must not access or
                        use the Platform or any related services. Please read
                        these General Terms and Conditions carefully before
                        accessing and using the website or the Scallop App.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-bh5l89 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s28">
                        <span className="framer-text termsandconditions-s29">
                          Please read carefully
                        </span>
                        <span className="framer-text termsandconditions-s29">
                          <br className="framer-text" />
                        </span>
                        <span className="framer-text termsandconditions-s29">
                          In these Terms and Conditions, &ldquo;Scallop&rdquo;,
                          &ldquo;we&rdquo;, &ldquo;us&rdquo; and
                          &ldquo;our&rdquo; refer to the{' '}
                        </span>
                        <span className="framer-text termsandconditions-s30">
                          <strong className="framer-text">Scallop Group</strong>
                        </span>
                        <span className="framer-text termsandconditions-s29">
                          , acting through the relevant entity involved in the
                          provision, operation, or support of the services.
                        </span>
                        <span className="framer-text termsandconditions-s29">
                          <br className="framer-text" />
                          <br className="framer-text" />
                        </span>
                        <span className="framer-text termsandconditions-s29">
                          By accessing or using the{' '}
                        </span>
                        <span className="framer-text termsandconditions-s30">
                          <strong className="framer-text">
                            Scallop Platform
                          </strong>
                        </span>
                        <span className="framer-text termsandconditions-s29">
                          , you are entering into a legally binding agreement
                          with the{' '}
                        </span>
                        <span className="framer-text termsandconditions-s30">
                          <strong className="framer-text">Scallop Group</strong>
                        </span>
                        <span className="framer-text termsandconditions-s29">
                          , acting through the relevant entity involved in the
                          provision, operation, or support of the services.
                          These Terms and Conditions explain how the Platform
                          operates, how services are made available, and the
                          rights and responsibilities that apply to you. Certain
                          services or features may be subject to additional or
                          separate terms. Where applicable, such terms will be
                          made available to you and shall form part of your
                          agreement. These Terms and Conditions and any
                          additional terms should be read together. Scallop does
                          not provide legal, tax, financial, or investment
                          advice. Any information made available through the
                          Platform or related materials is provided for general
                          information purposes only. You are solely responsible
                          for determining whether the services are suitable for
                          you and for understanding the contractual and
                          regulatory framework applicable to your use of the
                          Platform. You should consider obtaining independent
                          professional advice where appropriate and should only
                          proceed if you are comfortable with the risks,
                          obligations, and terms that apply. By accessing or
                          using the Platform, you confirm that you have read,
                          understood, and agree to be bound by these Terms and
                          Conditions. If you do not agree, you must not access
                          or use the Platform or any related services. Please
                          read these General Terms and Conditions carefully
                          before accessing and using the website or the Scallop
                          App.
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-199bwki termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 className="framer-text termsandconditions-s31">
                        1. Introduction&#8232;&#8232;
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-199bwki termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s32">
                        1. Introduction&#8232;&#8232;
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-kud5k0 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s33">
                        These Terms and Conditions govern your access to and use
                        of the Scallop website, mobile application and any
                        related Platform or services (collectively, the
                        Platform).
                        <br className="framer-text" />
                        <br className="framer-text" />
                        <strong className="framer-text">1.1</strong> The
                        Platform and related services are made available by the
                        Scallop Group, an international group of companies
                        operating under the Scallop brand, through one or more
                        of its entities.
                        <br className="framer-text" />
                        <strong className="framer-text">1.2</strong> Services
                        offered through the Platform may be provided, operated,
                        administered, or supported by different entities within
                        the Scallop Group, depending on the nature of the
                        service, the customer&rsquo;s location, and applicable
                        legal and regulatory requirements.
                        <span className="framer-text termsandconditions-s34">
                          <br className="framer-text" />
                        </span>
                        <strong className="framer-text">1.3</strong> Different
                        Scallop Group entities may be involved in the delivery
                        of specific services and may act in different capacities
                        in accordance with applicable licences and regulatory
                        permissions.
                        <span className="framer-text termsandconditions-s34">
                          <br className="framer-text" />
                        </span>
                        <strong className="framer-text">1.4</strong> Each
                        Scallop Group entity operates independently and in
                        accordance with the laws and regulatory requirements
                        applicable in its jurisdiction. Nothing in these Terms
                        and Conditions shall be construed as creating any
                        partnership, joint venture, or joint or several
                        liability between Scallop Group entities, unless
                        expressly stated otherwise.
                        <br className="framer-text" />
                        <strong className="framer-text">1.5</strong> These Terms
                        and Conditions apply to your use of the Platform and
                        form a legally binding agreement between you and the
                        relevant Scallop Group entity involved in the provision
                        of the relevant services.
                        <br className="framer-text" />
                        <strong className="framer-text">1.6</strong> The
                        customer may only use the Platform for personal use and
                        in accordance with this Agreement. The Agreement is for
                        an indefinite term and will remain in force until
                        terminated by you or by Scallop, acting through the
                        relevant Scallop Group entity, in accordance with this
                        Agreement.
                        <br className="framer-text" />
                        <strong className="framer-text">1.7</strong> The
                        language of the Agreement is English and all
                        communications will be conducted in English unless
                        otherwise stated in these Terms and Conditions. The
                        customer may download a copy of these Terms and
                        Conditions from the Platform at any time or request a
                        copy from Customer Support.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-kud5k0 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s35">
                        These Terms and Conditions govern your access to and use
                        of the Scallop website, mobile application and any
                        related Platform or services (collectively, the
                        Platform).
                        <br className="framer-text" />
                        <br className="framer-text" />
                        <strong className="framer-text">1.1</strong> The
                        Platform and related services are made available by the
                        Scallop Group, an international group of companies
                        operating under the Scallop brand, through one or more
                        of its entities.
                        <br className="framer-text" />
                        <strong className="framer-text">1.2</strong> Services
                        offered through the Platform may be provided, operated,
                        administered, or supported by different entities within
                        the Scallop Group, depending on the nature of the
                        service, the customer&rsquo;s location, and applicable
                        legal and regulatory requirements.
                        <span className="framer-text termsandconditions-s34">
                          <br className="framer-text" />
                        </span>
                        <strong className="framer-text">1.3</strong> Different
                        Scallop Group entities may be involved in the delivery
                        of specific services and may act in different capacities
                        in accordance with applicable licences and regulatory
                        permissions.
                        <span className="framer-text termsandconditions-s34">
                          <br className="framer-text" />
                        </span>
                        <strong className="framer-text">1.4</strong> Each
                        Scallop Group entity operates independently and in
                        accordance with the laws and regulatory requirements
                        applicable in its jurisdiction. Nothing in these Terms
                        and Conditions shall be construed as creating any
                        partnership, joint venture, or joint or several
                        liability between Scallop Group entities, unless
                        expressly stated otherwise.
                        <br className="framer-text" />
                        <strong className="framer-text">1.5</strong> These Terms
                        and Conditions apply to your use of the Platform and
                        form a legally binding agreement between you and the
                        relevant Scallop Group entity involved in the provision
                        of the relevant services.
                        <br className="framer-text" />
                        <strong className="framer-text">1.6</strong> The
                        customer may only use the Platform for personal use and
                        in accordance with this Agreement. The Agreement is for
                        an indefinite term and will remain in force until
                        terminated by you or by Scallop, acting through the
                        relevant Scallop Group entity, in accordance with this
                        Agreement.
                        <br className="framer-text" />
                        <strong className="framer-text">1.7</strong> The
                        language of the Agreement is English and all
                        communications will be conducted in English unless
                        otherwise stated in these Terms and Conditions. The
                        customer may download a copy of these Terms and
                        Conditions from the Platform at any time or request a
                        copy from Customer Support.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-1w6dfr7 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 className="framer-text termsandconditions-s31">
                        2. The customer&rsquo;s Platform Account&nbsp;
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-1w6dfr7 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s32">
                        2. The customer&rsquo;s Platform Account&nbsp;
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-fgguyj termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">2.0</strong> For the
                        purposes of these Terms and Conditions,
                        &ldquo;Contracting Entity&rdquo; means any Scallop Group
                        entity involved in the provision, operation, or support
                        of the relevant services, acting within its applicable
                        legal and regulatory framework.
                        <br className="framer-text" />
                        <strong className="framer-text">2.1.</strong> To use the
                        Platform, the customer will need to create a user
                        account (the &ldquo;Platform Account&rdquo;).
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">2.2.</strong> To be
                        eligible to use the Platform and to create a Platform
                        Account the customer needs to:
                      </p>
                      <ul dir="auto" className="framer-text termsandconditions-s26">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            be a private individual;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            at least eighteen (18) years of age; and
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            have accepted these Terms and Conditions.
                          </p>
                        </li>
                      </ul>
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">2.3.</strong> In
                        addition to the prerequisites set out in clause 2.2
                        above, the customer must only use their Platform Account
                        for their personal use and for legal purposes. They
                        cannot be listed on or associated with any sanctions
                        list, such as the sanctions list of the{' '}
                        <span className="framer-text termsandconditions-s27">
                          <strong className="framer-text">EU</strong>
                        </span>
                        , the{' '}
                        <span className="framer-text termsandconditions-s27">
                          <strong className="framer-text">UN</strong>
                        </span>{' '}
                        or{' '}
                        <span className="framer-text termsandconditions-s27">
                          <strong className="framer-text">OFAC</strong>
                        </span>
                        .
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-fgguyj termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">2.0</strong> For the
                        purposes of these Terms and Conditions,
                        &ldquo;Contracting Entity&rdquo; means any Scallop Group
                        entity involved in the provision, operation, or support
                        of the relevant services, acting within its applicable
                        legal and regulatory framework.
                        <br className="framer-text" />
                        <strong className="framer-text">2.1.</strong> To use the
                        Platform, the customer will need to create a user
                        account (the &ldquo;Platform Account&rdquo;).
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">2.2.</strong> To be
                        eligible to use the Platform and to create a Platform
                        Account the customer needs to:
                      </p>
                      <ul dir="auto" className="framer-text termsandconditions-s36">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            be a private individual;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            at least eighteen (18) years of age; and
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            have accepted these Terms and Conditions.
                          </p>
                        </li>
                      </ul>
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">2.3.</strong> In
                        addition to the prerequisites set out in clause 2.2
                        above, the customer must only use their Platform Account
                        for their personal use and for legal purposes. They
                        cannot be listed on or associated with any sanctions
                        list, such as the sanctions list of the{' '}
                        <span className="framer-text termsandconditions-s27">
                          <strong className="framer-text">EU</strong>
                        </span>
                        , the{' '}
                        <span className="framer-text termsandconditions-s27">
                          <strong className="framer-text">UN</strong>
                        </span>{' '}
                        or{' '}
                        <span className="framer-text termsandconditions-s27">
                          <strong className="framer-text">OFAC</strong>
                        </span>
                        .
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-h6c4pl termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 className="framer-text termsandconditions-s31">
                        3 How to create a Platform Account
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-h6c4pl termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s32">
                        3 How to create a Platform Account
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-9stvqt termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">3.1.</strong> To create
                        a Platform Account, the customer should complete the
                        onboarding process, following all the steps mentioned on
                        the Platform and providing true and accurate
                        information.
                        <br className="framer-text" />
                        <strong className="framer-text">3.2.</strong> When
                        applying for their Platform Account, the customer
                        acknowledges and guarantees that:
                      </p>
                      <ul dir="auto" className="framer-text termsandconditions-s26">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they will utilise the Platform Account for their
                            personal use and for legitimate purposes only;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            any information and documentation provided by them
                            is authentic, up-to-date, true and correct;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            the customer will comply with the provisions of the
                            Agreement; and
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            the customer will respect our and our third
                            parties&apos; intellectual property rights relating
                            to the products and services offered to you under
                            the Agreement.
                          </p>
                        </li>
                      </ul>
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">3.3.</strong> Please
                        note that the customer needs to inform our Customer
                        Support without undue delay of any change of residential
                        address or any other information relevant to your use of
                        the Platform.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-9stvqt termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">3.1.</strong> To create
                        a Platform Account, the customer should complete the
                        onboarding process, following all the steps mentioned on
                        the Platform and providing true and accurate
                        information.
                        <br className="framer-text" />
                        <strong className="framer-text">3.2.</strong> When
                        applying for their Platform Account, the customer
                        acknowledges and guarantees that:
                      </p>
                      <ul dir="auto" className="framer-text termsandconditions-s36">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they will utilise the Platform Account for their
                            personal use and for legitimate purposes only;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            any information and documentation provided by them
                            is authentic, up-to-date, true and correct;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            the customer will comply with the provisions of the
                            Agreement; and
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            the customer will respect our and our third
                            parties&apos; intellectual property rights relating
                            to the products and services offered to you under
                            the Agreement.
                          </p>
                        </li>
                      </ul>
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">3.3.</strong> Please
                        note that the customer needs to inform our Customer
                        Support without undue delay of any change of residential
                        address or any other information relevant to your use of
                        the Platform.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-1vs437s termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s31">
                        4 Customer support and complaints
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-1vs437s termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s32">
                        4 Customer support and complaints
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-59d8i5 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s37">
                        <strong className="framer-text">4.1.</strong> Scallop
                        will provide customer support services relating to the
                        Platform as well as the Account (&quot;Customer
                        Support&quot;) and the customer is welcome to contact
                        Customer Support if they have any questions about the
                        Platform or your Account. Customer Support is accessible
                        via in-app chat/email on{' '}
                        <span className="framer-text termsandconditions-s27">
                          <strong className="framer-text">
                            support@scallopx.com
                          </strong>
                        </span>{' '}
                        in the English language.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s37">
                        <strong className="framer-text">4.2.</strong> The
                        customer acknowledges and understands that Customer
                        Support constitutes a first support line, and that
                        Customer Support may need to contact other partners of
                        Scallop engaged for the supply of the Platform for
                        second line support as necessary.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s37">
                        <strong className="framer-text">4.3.</strong> For any
                        complaints or claims the customer may have regarding
                        faults or deficiencies in products or services that they
                        have purchased through their Account, the customer
                        should contact the seller of the product or the service
                        provider (i.e. the point of sales) directly. The seller
                        or service provider is liable for such faults or
                        deficiencies in accordance with laws applicable to the
                        purchase, and Scallop does not assume any liability
                        regarding such faults or deficiencies.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s37">
                        <strong className="framer-text">4.4.</strong> Complaints
                        will be addressed within 15 business days, extendable to
                        35 in exceptional cases.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-59d8i5 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s38">
                        <strong className="framer-text">4.1.</strong> Scallop
                        will provide customer support services relating to the
                        Platform as well as the Account (&quot;Customer
                        Support&quot;) and the customer is welcome to contact
                        Customer Support if they have any questions about the
                        Platform or your Account. Customer Support is accessible
                        via in-app chat/email on{' '}
                        <span className="framer-text termsandconditions-s27">
                          <strong className="framer-text">
                            support@scallopx.com
                          </strong>
                        </span>{' '}
                        in the English language.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s38">
                        <strong className="framer-text">4.2.</strong> The
                        customer acknowledges and understands that Customer
                        Support constitutes a first support line, and that
                        Customer Support may need to contact other partners of
                        Scallop engaged for the supply of the Platform for
                        second line support as necessary.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s38">
                        <strong className="framer-text">4.3.</strong> For any
                        complaints or claims the customer may have regarding
                        faults or deficiencies in products or services that they
                        have purchased through their Account, the customer
                        should contact the seller of the product or the service
                        provider (i.e. the point of sales) directly. The seller
                        or service provider is liable for such faults or
                        deficiencies in accordance with laws applicable to the
                        purchase, and Scallop does not assume any liability
                        regarding such faults or deficiencies.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s38">
                        <strong className="framer-text">4.4.</strong> Complaints
                        will be addressed within 15 business days, extendable to
                        35 in exceptional cases.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-1gx7ao7 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s31">
                        5. The customer&rsquo;s personal data
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-1gx7ao7 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s32">
                        5. The customer&rsquo;s personal data
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-8vehii termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">5.1.</strong> Personal
                        data is collected and processed by the relevant Scallop
                        Group entity involved in the provision of the Platform
                        and related services. Third-party service providers,
                        including identity verification providers such as
                        Sumsub, act as data processors in accordance with
                        applicable data protection laws and contractual
                        arrangements.
                        <br className="framer-text" />
                        <strong className="framer-text">5.2.</strong> It is
                        Scallop&apos;s duty to keep the personal data that we
                        process about our customers safe and secure. We will not
                        disclose information relating to their Platform Account
                        to third parties outside the circle of trusted suppliers
                        we work with to provide the Platform, other than as
                        required by applicable data protection laws and
                        regulatory requirements in the relevant jurisdiction.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">5.3.</strong> It is
                        important that the customers understand how Scallop
                        processes the customer&rsquo;s personal data. We value
                        our customers&apos; privacy and process and protect
                        personal data in accordance with applicable data
                        protection laws and regulations.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">5.4</strong> In order to
                        create and maintain a Platform Account and to provide
                        services to you, Scallop Group entities may be required
                        to collect, verify, process, and share your personal
                        data, including identification and due diligence
                        information, for the purposes of customer onboarding,
                        identity verification, fraud prevention, anti-money
                        laundering and counter-terrorist financing checks,
                        sanctions screening, and ongoing monitoring (&ldquo;KYC
                        and Due Diligence Purposes&rdquo;). For these purposes,
                        your personal data may be shared with trusted third
                        parties engaged by the relevant Contracting Entity,
                        including but not limited to identity verification
                        providers, financial institutions, payment service
                        providers, banks, processors, compliance service
                        providers, and regulatory or supervisory authorities,
                        where required by applicable laws or regulatory
                        obligations.
                        <br className="framer-text" />
                        By accepting these Terms and Conditions and proceeding
                        with account creation or use of the Platform, you
                        expressly consent to the collection, use, processing,
                        and sharing of your personal data for KYC and Due
                        Diligence Purposes as described above. Such processing
                        and sharing shall be carried out in accordance with
                        applicable data protection laws and the Scallop Privacy
                        Policy
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-8vehii termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">5.1.</strong> Personal
                        data is collected and processed by the relevant Scallop
                        Group entity involved in the provision of the Platform
                        and related services. Third-party service providers,
                        including identity verification providers such as
                        Sumsub, act as data processors in accordance with
                        applicable data protection laws and contractual
                        arrangements.
                        <br className="framer-text" />
                        <strong className="framer-text">5.2.</strong> It is
                        Scallop&apos;s duty to keep the personal data that we
                        process about our customers safe and secure. We will not
                        disclose information relating to their Platform Account
                        to third parties outside the circle of trusted suppliers
                        we work with to provide the Platform, other than as
                        required by applicable data protection laws and
                        regulatory requirements in the relevant jurisdiction.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">5.3.</strong> It is
                        important that the customers understand how Scallop
                        processes the customer&rsquo;s personal data. We value
                        our customers&apos; privacy and process and protect
                        personal data in accordance with applicable data
                        protection laws and regulations.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">5.4</strong> In order to
                        create and maintain a Platform Account and to provide
                        services to you, Scallop Group entities may be required
                        to collect, verify, process, and share your personal
                        data, including identification and due diligence
                        information, for the purposes of customer onboarding,
                        identity verification, fraud prevention, anti-money
                        laundering and counter-terrorist financing checks,
                        sanctions screening, and ongoing monitoring (&ldquo;KYC
                        and Due Diligence Purposes&rdquo;). For these purposes,
                        your personal data may be shared with trusted third
                        parties engaged by the relevant Contracting Entity,
                        including but not limited to identity verification
                        providers, financial institutions, payment service
                        providers, banks, processors, compliance service
                        providers, and regulatory or supervisory authorities,
                        where required by applicable laws or regulatory
                        obligations.
                        <br className="framer-text" />
                        By accepting these Terms and Conditions and proceeding
                        with account creation or use of the Platform, you
                        expressly consent to the collection, use, processing,
                        and sharing of your personal data for KYC and Due
                        Diligence Purposes as described above. Such processing
                        and sharing shall be carried out in accordance with
                        applicable data protection laws and the Scallop Privacy
                        Policy
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-ap1lk1 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s31">
                        6. Fees and charges
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-ap1lk1 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s32">
                        6. Fees and charges
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-1saaiy7 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s37">
                        <strong className="framer-text">6.1.</strong> There will
                        be two accounts offered on the Platform and the
                        customer&rsquo;s Basic Account will be provided free of
                        charge, however the Elite account will be at a cost,
                        which will be decided. There are no fees or charges
                        associated with using the Basic Account, and no pricing
                        information is available due to the fact that the
                        account is completely free to use. However, this may be
                        subject to change, and users will be duly informed of
                        any updates accordingly.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s37">
                        <strong className="framer-text">6.2.</strong> Incorrect
                        Payments. Errors in payment details must be reported
                        within 13 months of the error occurring. Efforts to
                        trace incorrect payments may incur further fees and
                        charges.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-1saaiy7 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s38">
                        <strong className="framer-text">6.1.</strong> There will
                        be two accounts offered on the Platform and the
                        customer&rsquo;s Basic Account will be provided free of
                        charge, however the Elite account will be at a cost,
                        which will be decided. There are no fees or charges
                        associated with using the Basic Account, and no pricing
                        information is available due to the fact that the
                        account is completely free to use. However, this may be
                        subject to change, and users will be duly informed of
                        any updates accordingly.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s38">
                        <strong className="framer-text">6.2.</strong> Incorrect
                        Payments. Errors in payment details must be reported
                        within 13 months of the error occurring. Efforts to
                        trace incorrect payments may incur further fees and
                        charges.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-1jn1i5s termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s31">
                        7. Service-Specific Terms and Disclaimers
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-1jn1i5s termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s32">
                        7. Service-Specific Terms and Disclaimers
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-31x3gp termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">7.1.</strong> Fiat
                        Account and Payment Services. Where available, the
                        Platform may allow customers to access fiat account and
                        payment services, including the holding of fiat balances
                        and the execution of payment transactions. Fiat services
                        are provided by the relevant Scallop Group entity and/or
                        its regulated third-party payment service providers,
                        subject to applicable licensing, regulatory permissions,
                        and local legal requirements. Fiat accounts made
                        available through the Platform are not bank accounts
                        unless expressly stated otherwise. Customer funds may be
                        safeguarded in accordance with applicable laws and
                        regulatory requirements, where required. The
                        availability of fiat services, execution times, limits,
                        fees, and applicable protections may vary depending on
                        the customer&rsquo;s location and the nature of the
                        service.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">7.2.</strong> Card
                        Services. Where available, the Platform may provide
                        access to card services, including debit or prepaid
                        cards, issued by third-party card issuers or programme
                        managers. Card services are subject to separate terms,
                        card scheme rules, issuer conditions, and applicable
                        laws. Scallop does not itself issue cards unless
                        expressly stated. Card availability, features, limits,
                        fees, suspension rights, chargeback processes, and
                        transaction authorisation are governed by the applicable
                        card issuer and card scheme. Scallop is not responsible
                        for the actions or decisions of card issuers or card
                        networks. Funds loaded onto virtual or physical cards
                        made available through the Platform are intended for
                        payment transactions only. Unless expressly stated
                        otherwise, card balances cannot be withdrawn,
                        transferred back to a Platform Account, or refunded once
                        loaded. Further details, including applicable
                        limitations and exceptions, are set out in the Refunds
                        and Chargebacks Policy.
                        <br className="framer-text" />
                        <strong className="framer-text">7.3</strong> Crypto
                        Wallet and Digital Asset Services. Where available, the
                        Platform may allow customers to access digital asset
                        services, including crypto wallets and custody or
                        facilitation of digital asset transactions. Such
                        services are provided by the relevant Scallop Group
                        entity and/or third-party custodians or infrastructure
                        providers, acting within their applicable regulatory
                        permissions. Digital assets are not legal tender and are
                        not backed by any government or central authority.
                        Ownership, custody arrangements, transaction processing,
                        and service availability may vary depending on the
                        specific digital asset and the applicable service model.
                        Customers acknowledge that digital asset services are
                        subject to technical, regulatory, and operational risks.
                        <br className="framer-text" />
                        <strong className="framer-text">7.4</strong> Swap
                        Services. Where available, the Platform may enable
                        customers to exchange or swap fiat currencies and/or
                        digital assets. Swap services may be executed directly
                        or through third-party liquidity providers or exchanges.
                        Pricing for swaps is indicative and may be subject to
                        spreads, fees, market liquidity, execution timing, and
                        volatility. Scallop does not guarantee that quoted
                        prices will remain available at the time of execution.
                        Additional terms may apply to swap services and will be
                        made available where relevant.
                        <br className="framer-text" />
                        <strong className="framer-text">7.5</strong> Crypto and
                        Digital Asset Risk Disclosure. Customers acknowledge and
                        accept that digital assets are inherently volatile and
                        carry a high level of risk. The value of digital assets
                        may fluctuate significantly over short periods, and
                        customers may lose some or all of their invested value.
                        Risks associated with digital assets include, but are
                        not limited to, market volatility, liquidity risk,
                        technological failures, cybersecurity incidents,
                        regulatory changes, forks, protocol failures, and
                        third-party service provider failures. Customers should
                        only use digital asset services if they fully understand
                        these risks and are financially able to bear potential
                        losses.
                        <br className="framer-text" />
                        <strong className="framer-text">7.6</strong> No Deposit
                        or Interest Guarantee Disclaimer. Unless expressly
                        stated otherwise, fiat balances and digital assets held
                        or facilitated through the Platform do not earn interest
                        and are not protected by deposit guarantee schemes,
                        investor compensation schemes, or similar protections.
                        Digital assets are not deposits and do not benefit from
                        any statutory protection applicable to bank deposits.
                        Customers acknowledge that protections available under
                        applicable law may differ depending on the service and
                        jurisdiction.
                        <br className="framer-text" />
                        <strong className="framer-text">7.7</strong> Third-Party
                        Providers and Partners Disclaimer. Scallop relies on
                        third-party service providers, including banks, payment
                        service providers, card issuers, custodians, processors,
                        and technology partners, to deliver certain services
                        through the Platform. Scallop is not responsible for the
                        acts, omissions, outages, or decisions of third-party
                        providers, including decisions to onboard, suspend,
                        restrict, or terminate services. The availability and
                        functionality of services may be affected by third-party
                        providers beyond Scallop&rsquo;s reasonable control.
                        <br className="framer-text" />
                        <strong className="framer-text">7.8</strong> Transaction
                        Finality and Irreversibility. Customers acknowledge that
                        certain transactions, particularly digital asset
                        transactions, are final and irreversible once executed
                        and recorded on the relevant blockchain or system.
                        Scallop may not be able to reverse, cancel, or recover
                        transactions once initiated by the customer, even if the
                        transaction was made in error. Customers are solely
                        responsible for ensuring the accuracy of transaction
                        details before confirming any transaction.
                        <br className="framer-text" />
                        <strong className="framer-text">7.9</strong> Market
                        Volatility and Pricing Disclaimer. Prices, exchange
                        rates, and valuations displayed on the Platform are
                        indicative only and may be affected by market
                        volatility, liquidity conditions, data sources, and
                        execution timing. Scallop does not guarantee the
                        accuracy, completeness, or timeliness of pricing
                        information and is not responsible for losses arising
                        from price movements or discrepancies between displayed
                        and executed prices.
                        <br className="framer-text" />
                        <strong className="framer-text">7.10</strong> Service
                        Availability and Suspension. Scallop may suspend,
                        restrict, or terminate access to any part of the
                        Platform or specific services at any time where required
                        for regulatory compliance, security, fraud prevention,
                        anti-money laundering purposes, operational reasons, or
                        due to third-party service disruptions. In certain
                        circumstances, Scallop may be legally prohibited from
                        informing customers of the reasons for such actions.
                        Service availability may vary by jurisdiction and may
                        change from time to time.{' '}
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-31x3gp termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">7.1.</strong> Fiat
                        Account and Payment Services. Where available, the
                        Platform may allow customers to access fiat account and
                        payment services, including the holding of fiat balances
                        and the execution of payment transactions. Fiat services
                        are provided by the relevant Scallop Group entity and/or
                        its regulated third-party payment service providers,
                        subject to applicable licensing, regulatory permissions,
                        and local legal requirements. Fiat accounts made
                        available through the Platform are not bank accounts
                        unless expressly stated otherwise. Customer funds may be
                        safeguarded in accordance with applicable laws and
                        regulatory requirements, where required. The
                        availability of fiat services, execution times, limits,
                        fees, and applicable protections may vary depending on
                        the customer&rsquo;s location and the nature of the
                        service.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">7.2.</strong> Card
                        Services. Where available, the Platform may provide
                        access to card services, including debit or prepaid
                        cards, issued by third-party card issuers or programme
                        managers. Card services are subject to separate terms,
                        card scheme rules, issuer conditions, and applicable
                        laws. Scallop does not itself issue cards unless
                        expressly stated. Card availability, features, limits,
                        fees, suspension rights, chargeback processes, and
                        transaction authorisation are governed by the applicable
                        card issuer and card scheme. Scallop is not responsible
                        for the actions or decisions of card issuers or card
                        networks. Funds loaded onto virtual or physical cards
                        made available through the Platform are intended for
                        payment transactions only. Unless expressly stated
                        otherwise, card balances cannot be withdrawn,
                        transferred back to a Platform Account, or refunded once
                        loaded. Further details, including applicable
                        limitations and exceptions, are set out in the Refunds
                        and Chargebacks Policy.
                        <br className="framer-text" />
                        <strong className="framer-text">7.3</strong> Crypto
                        Wallet and Digital Asset Services. Where available, the
                        Platform may allow customers to access digital asset
                        services, including crypto wallets and custody or
                        facilitation of digital asset transactions. Such
                        services are provided by the relevant Scallop Group
                        entity and/or third-party custodians or infrastructure
                        providers, acting within their applicable regulatory
                        permissions. Digital assets are not legal tender and are
                        not backed by any government or central authority.
                        Ownership, custody arrangements, transaction processing,
                        and service availability may vary depending on the
                        specific digital asset and the applicable service model.
                        Customers acknowledge that digital asset services are
                        subject to technical, regulatory, and operational risks.
                        <br className="framer-text" />
                        <strong className="framer-text">7.4</strong> Swap
                        Services. Where available, the Platform may enable
                        customers to exchange or swap fiat currencies and/or
                        digital assets. Swap services may be executed directly
                        or through third-party liquidity providers or exchanges.
                        Pricing for swaps is indicative and may be subject to
                        spreads, fees, market liquidity, execution timing, and
                        volatility. Scallop does not guarantee that quoted
                        prices will remain available at the time of execution.
                        Additional terms may apply to swap services and will be
                        made available where relevant.
                        <br className="framer-text" />
                        <strong className="framer-text">7.5</strong> Crypto and
                        Digital Asset Risk Disclosure. Customers acknowledge and
                        accept that digital assets are inherently volatile and
                        carry a high level of risk. The value of digital assets
                        may fluctuate significantly over short periods, and
                        customers may lose some or all of their invested value.
                        Risks associated with digital assets include, but are
                        not limited to, market volatility, liquidity risk,
                        technological failures, cybersecurity incidents,
                        regulatory changes, forks, protocol failures, and
                        third-party service provider failures. Customers should
                        only use digital asset services if they fully understand
                        these risks and are financially able to bear potential
                        losses.
                        <br className="framer-text" />
                        <strong className="framer-text">7.6</strong> No Deposit
                        or Interest Guarantee Disclaimer. Unless expressly
                        stated otherwise, fiat balances and digital assets held
                        or facilitated through the Platform do not earn interest
                        and are not protected by deposit guarantee schemes,
                        investor compensation schemes, or similar protections.
                        Digital assets are not deposits and do not benefit from
                        any statutory protection applicable to bank deposits.
                        Customers acknowledge that protections available under
                        applicable law may differ depending on the service and
                        jurisdiction.
                        <br className="framer-text" />
                        <strong className="framer-text">7.7</strong> Third-Party
                        Providers and Partners Disclaimer. Scallop relies on
                        third-party service providers, including banks, payment
                        service providers, card issuers, custodians, processors,
                        and technology partners, to deliver certain services
                        through the Platform. Scallop is not responsible for the
                        acts, omissions, outages, or decisions of third-party
                        providers, including decisions to onboard, suspend,
                        restrict, or terminate services. The availability and
                        functionality of services may be affected by third-party
                        providers beyond Scallop&rsquo;s reasonable control.
                        <br className="framer-text" />
                        <strong className="framer-text">7.8</strong> Transaction
                        Finality and Irreversibility. Customers acknowledge that
                        certain transactions, particularly digital asset
                        transactions, are final and irreversible once executed
                        and recorded on the relevant blockchain or system.
                        Scallop may not be able to reverse, cancel, or recover
                        transactions once initiated by the customer, even if the
                        transaction was made in error. Customers are solely
                        responsible for ensuring the accuracy of transaction
                        details before confirming any transaction.
                        <br className="framer-text" />
                        <strong className="framer-text">7.9</strong> Market
                        Volatility and Pricing Disclaimer. Prices, exchange
                        rates, and valuations displayed on the Platform are
                        indicative only and may be affected by market
                        volatility, liquidity conditions, data sources, and
                        execution timing. Scallop does not guarantee the
                        accuracy, completeness, or timeliness of pricing
                        information and is not responsible for losses arising
                        from price movements or discrepancies between displayed
                        and executed prices.
                        <br className="framer-text" />
                        <strong className="framer-text">7.10</strong> Service
                        Availability and Suspension. Scallop may suspend,
                        restrict, or terminate access to any part of the
                        Platform or specific services at any time where required
                        for regulatory compliance, security, fraud prevention,
                        anti-money laundering purposes, operational reasons, or
                        due to third-party service disruptions. In certain
                        circumstances, Scallop may be legally prohibited from
                        informing customers of the reasons for such actions.
                        Service availability may vary by jurisdiction and may
                        change from time to time.{' '}
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-7hud74 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s31">
                        8. Platform Account security
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-7hud74 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s32">
                        8. Platform Account security
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-pydz16 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">8.1.</strong>{' '}
                        Unauthorised Use. If the customer becomes aware or
                        suspects that someone has used their Platform Account
                        without their authorisation they must contact Customer
                        Support as soon as they are able. Otherwise, the
                        customer will be liable for any such unauthorised access
                        to their Platform Account. If they are notified about
                        any suspicious activity in their Platform Account they
                        need to inform Customer Support as soon as possible from
                        such notification that the incursion to their account
                        was unauthorized.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">8.2.</strong> The
                        customer&rsquo;s responsibility. The customer is
                        responsible for keeping their Platform Account safe.
                        Whilst measures are undertaken to protect our customers
                        Platform Account, please note that the customers are
                        responsible for ensuring that:
                      </p>
                      <ul dir="auto" className="framer-text termsandconditions-s26">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            their Platform Account and their credentials,
                            ordinary and one-time passwords, means of
                            communication used with Scallop for authentication
                            purposes (&ldquo;account credentials&rdquo;) are
                            kept safe and secure and that they do not keep
                            account credentials or security details together
                            with a device used to access the Platform;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they use a strong password, which they do not use
                            for any other account or similar, which they update
                            from time to time;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they do not let any third party access or use the
                            Platform Account;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they immediately contact Customer Support if they
                            suspect or experience that their Platform Account
                            (or any information thereof) is accessed or
                            otherwise used by an unauthorised third party or if
                            they suspect that any account credentials are at a
                            risk of or are being used or otherwise possessed by
                            an unauthorised third party;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they ensure that all information (including but not
                            limited to your contact details and address)
                            relating to the Platform Account is up-to-date and
                            that they will inform Customer Support without undue
                            delay of any change; and
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they always follow the rules and recommendations
                            regarding security of their Platform Account.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-pydz16 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">8.1.</strong>{' '}
                        Unauthorised Use. If the customer becomes aware or
                        suspects that someone has used their Platform Account
                        without their authorisation they must contact Customer
                        Support as soon as they are able. Otherwise, the
                        customer will be liable for any such unauthorised access
                        to their Platform Account. If they are notified about
                        any suspicious activity in their Platform Account they
                        need to inform Customer Support as soon as possible from
                        such notification that the incursion to their account
                        was unauthorized.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">8.2.</strong> The
                        customer&rsquo;s responsibility. The customer is
                        responsible for keeping their Platform Account safe.
                        Whilst measures are undertaken to protect our customers
                        Platform Account, please note that the customers are
                        responsible for ensuring that:
                      </p>
                      <ul dir="auto" className="framer-text termsandconditions-s36">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            their Platform Account and their credentials,
                            ordinary and one-time passwords, means of
                            communication used with Scallop for authentication
                            purposes (&ldquo;account credentials&rdquo;) are
                            kept safe and secure and that they do not keep
                            account credentials or security details together
                            with a device used to access the Platform;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they use a strong password, which they do not use
                            for any other account or similar, which they update
                            from time to time;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they do not let any third party access or use the
                            Platform Account;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they immediately contact Customer Support if they
                            suspect or experience that their Platform Account
                            (or any information thereof) is accessed or
                            otherwise used by an unauthorised third party or if
                            they suspect that any account credentials are at a
                            risk of or are being used or otherwise possessed by
                            an unauthorised third party;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they ensure that all information (including but not
                            limited to your contact details and address)
                            relating to the Platform Account is up-to-date and
                            that they will inform Customer Support without undue
                            delay of any change; and
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            they always follow the rules and recommendations
                            regarding security of their Platform Account.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-1ttklqu termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s31">
                        9. Changing the Agreement, closing your Platform Account
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-1ttklqu termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s32">
                        9. Changing the Agreement, closing your Platform Account
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-1g09eot termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">9.1</strong> Scallop may
                        amend or update the Agreement (including these Terms and
                        Conditions and the Privacy Policy) at any time, for
                        example to introduce new products or services or to
                        comply with applicable laws or regulatory requirements.
                        Any such changes will take effect immediately upon
                        publication on the Platform. Your continued access to or
                        use of the Platform after such publication constitutes
                        your acceptance of the updated Agreement.
                        <br className="framer-text" />
                        <strong className="framer-text">9.2</strong> The
                        customer can terminate the Agreement free of charge and
                        close the Platform Account at any time without notice.
                        In this case, the customer should contact Customer
                        Support if they wish to terminate their Platform
                        Account.
                        <br className="framer-text" />
                        <strong className="framer-text">9.3</strong> Scallop can
                        terminate the Agreement with our customers and close the
                        Platform Account with two (2) months&rsquo; prior notice
                        for any reason.
                        <br className="framer-text" />
                        <strong className="framer-text">9.4</strong> In
                        addition, we may (i) suspend the customer&rsquo;s
                        Platform Account (or any part thereof), or (ii)
                        terminate the Agreement and the customer&rsquo;s
                        Platform Account (or any part thereof) with immediate
                        effect if they, in our opinion, materially breach the
                        Agreement, any applicable laws or if Scallop is required
                        to do so under any law, regulation, court order, or
                        request of an authority.
                        <br className="framer-text" />
                        <strong className="framer-text">9.5</strong> In certain
                        circumstances Scallop is prevented from closing the
                        Platform Account due to ongoing investigations
                        concerning the Platform Account. In such cases we may
                        freeze the Platform Account to complete the
                        investigation.
                        <br className="framer-text" />
                        <strong className="framer-text">9.6</strong> The
                        customer will be notified prior to their Platform
                        Account being closed, where legally permitted.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-1g09eot termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">9.1</strong> Scallop may
                        amend or update the Agreement (including these Terms and
                        Conditions and the Privacy Policy) at any time, for
                        example to introduce new products or services or to
                        comply with applicable laws or regulatory requirements.
                        Any such changes will take effect immediately upon
                        publication on the Platform. Your continued access to or
                        use of the Platform after such publication constitutes
                        your acceptance of the updated Agreement.
                        <br className="framer-text" />
                        <strong className="framer-text">9.2</strong> The
                        customer can terminate the Agreement free of charge and
                        close the Platform Account at any time without notice.
                        In this case, the customer should contact Customer
                        Support if they wish to terminate their Platform
                        Account.
                        <br className="framer-text" />
                        <strong className="framer-text">9.3</strong> Scallop can
                        terminate the Agreement with our customers and close the
                        Platform Account with two (2) months&rsquo; prior notice
                        for any reason.
                        <br className="framer-text" />
                        <strong className="framer-text">9.4</strong> In
                        addition, we may (i) suspend the customer&rsquo;s
                        Platform Account (or any part thereof), or (ii)
                        terminate the Agreement and the customer&rsquo;s
                        Platform Account (or any part thereof) with immediate
                        effect if they, in our opinion, materially breach the
                        Agreement, any applicable laws or if Scallop is required
                        to do so under any law, regulation, court order, or
                        request of an authority.
                        <br className="framer-text" />
                        <strong className="framer-text">9.5</strong> In certain
                        circumstances Scallop is prevented from closing the
                        Platform Account due to ongoing investigations
                        concerning the Platform Account. In such cases we may
                        freeze the Platform Account to complete the
                        investigation.
                        <br className="framer-text" />
                        <strong className="framer-text">9.6</strong> The
                        customer will be notified prior to their Platform
                        Account being closed, where legally permitted.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-11a43u8 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s31">
                        10. Additional legal terms
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-11a43u8 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s32">
                        10. Additional legal terms
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-o841ji termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">10.1 </strong>Account
                        functionality. The customer acknowledges, understands
                        and accepts that Scallop will in no event, except for
                        the provision of Customer Support, assume any liability
                        for the functionality of the Account, including but not
                        limited to any of the functionalities referred to in the
                        foregoing.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">10.2</strong> Changes to
                        the Platform. Scallop may need to make changes, updates
                        and upgrades to the Platform as it sees fit from time to
                        time. In such a case, the customer will be notified in
                        advance.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">10.3</strong>{' '}
                        Inactivity. If the customer&rsquo;s Platform Account is
                        inactive, meaning that no log-in has occurred for a
                        period longer than six (6) months, Scallop has the right
                        to terminate the Agreement with the customer and close
                        their Platform Account.
                        <br className="framer-text" />
                        <strong className="framer-text">10.4</strong>{' '}
                        Intellectual property rights. Upon entering into the
                        Agreement, Scallop grants their customers a limited,
                        non-exclusive, non-sublicensable, non-transferable,
                        revocable right to use the Platform. All the
                        intellectual property in the Platform are owned by us or
                        our licensors (such as our logo and designs, the content
                        on the Platform, all software and source code,
                        trademarks, know-how, and data related to the Platform).
                        The customer doesn&rsquo;t have any right to use our or
                        our licensors&rsquo; names, trademarks, logos or other
                        intellectual property. The customer must not copy,
                        reproduce, modify, reverse engineer or disassemble any
                        of our products, services or any intellectual property
                        rights.
                        <br className="framer-text" />
                        <strong className="framer-text">10.5</strong>{' '}
                        Performance analytics. To ensure that the services work
                        as intended and in order to provide our customers with
                        the best customer service possible, we conduct
                        performance analytics based on data shared with us. Our
                        customers should refer to our privacy policy if they
                        would like to know more about our processing of personal
                        data.
                        <br className="framer-text" />
                        <strong className="framer-text">10.6</strong>{' '}
                        Scallop&rsquo;s liability. The Platform is provided
                        &ldquo;as is&rdquo; and we cannot guarantee that the
                        Platform will be free from faults or interruptions. This
                        is partly due to the fact that we rely on some third
                        parties to provide the Platform.
                        <br className="framer-text" />
                        <strong className="framer-text">10.7</strong> Scallop is
                        not liable for any services provided by third parties to
                        our customers, and we do not undertake any
                        responsibility in relation thereto.
                        <br className="framer-text" />
                        <strong className="framer-text">10.8</strong>{' '}
                        Unauthorised payments. Users may be liable for
                        unauthorised transactions up to a maximum amount of
                        &euro;35 (or the equivalent amount under applicable law)
                        until a lost or stolen payment instrument is reported,
                        where applicable under mandatory law. Refunds, where
                        required by applicable law, are processed by the next
                        business day.
                        <br className="framer-text" />
                        <strong className="framer-text">10.9</strong> Exclusions
                        of liability. In addition to the above and to the extent
                        such limitation is permitted by law, Scallop will not be
                        responsible:
                      </p>
                      <ul dir="auto" className="framer-text termsandconditions-s26">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any indirect, punitive or consequential damages
                            or losses including but not limited to loss of
                            profit, loss of data, loss of business, loss of
                            goodwill and loss of reputation;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any damages, losses or costs in connection with
                            or due to compliance with applicable laws,
                            regulations, orders and decisions of courts or
                            authorities or other regulatory requirements of
                            payment systems, card payment systems or any other
                            payment, clearing or settlement system;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any damages, losses or costs in connection with
                            or due to any delays, interruptions, faults or
                            inaccuracies relating to the Platform;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any damages, losses or costs caused by a virus,
                            malware, phishing or other technological attacks or
                            harmful material that may infect the customers IT
                            equipment and infrastructure being used for the
                            Platform;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any damages, losses or costs that arise in
                            connection with or due to unauthorised transactions;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any damages, losses or costs arising in
                            connection with or due to third party&rsquo;s
                            decision (i) not to onboard you and open an Account
                            for the customer, (ii) close their Account, or (iii)
                            reject a transaction; or
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any fraudulent act conducted by any third party
                            contacting you posing to be representing for example
                            us, a well-known company or an acquaintance of a
                            natural person related to our customer asking them
                            to disclose their customer details such as password,
                            logins etc. Never we request that kind of
                            information or undertake any such action.
                          </p>
                        </li>
                      </ul>
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        <strong className="framer-text">10.10.</strong> Force
                        Majeure. We shall not be liable for any breach or delay
                        in the performance of our obligations under the
                        Agreement if such breach or delay is caused, directly or
                        indirectly, by fire, flood, earthquake, elements of
                        nature, wars (incl. cyberwar), civil or military
                        disturbances, acts of terrorism, sabotage, strikes,
                        riots, epidemic, pandemic, or any cause beyond our
                        reasonable control (&ldquo;force majeure event&rdquo;).
                        Should a force majeure event occur, the customer will be
                        notified thereof and Scallop will be excused from
                        performance of the obligations being affected for as
                        long as such force majeure event prevails.
                        <br className="framer-text" />
                        <strong className="framer-text">10.11.</strong>{' '}
                        Severability. If any of the provisions of the Agreement
                        is deemed invalid, unlawful or unenforceable, the
                        remaining provisions of the Agreement shall continue to
                        be valid and binding on the customer and us.
                        <br className="framer-text" />
                        <strong className="framer-text">10.12.</strong>{' '}
                        Assignment. The customer may not assign their rights or
                        obligations under the Agreement to a third party and
                        they are the sole party to the Agreement with us. The
                        customer is liable until the Platform Account is
                        terminated. Scallop may assign its rights or obligations
                        under the Agreement to a group company or to any third
                        party without your prior consent.
                        <br className="framer-text" />
                        <strong className="framer-text">10.13.</strong> No
                        waiver. Scallop has the right to exercise any right or
                        remedy it has under the Agreement at any time, even if
                        such exercise is delayed, or we previously failed to
                        exercise any right or remedy it is entitled to.
                        <br className="framer-text" />
                        <strong className="framer-text">10.14.</strong> Dispute
                        resolution. If the customer is dissatisfied with the
                        Platform or their Platform Account, they should contact
                        Customer Support in the first instance. To submit a
                        formal complaint, the customer must do so in writing,
                        providing the relevant circumstances and details of the
                        complaint. Where applicable, customers may have the
                        option to use alternative dispute resolution or consumer
                        protection mechanisms available in their jurisdiction.
                        For customers located in the European Union, this may
                        include the use of the European Union&rsquo;s online
                        dispute resolution platform available at {/*$*/}
                        <a className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="https://consumer-redress.ec.europa.eu/site-relocation_en?event=main.trader.register" target="_blank" rel="noopener">
                          <span className="framer-text termsandconditions-s39">
                            https://ec.europa.eu/consumers/odr/main/?event=main.trader.register
                          </span>
                        </a>
                        {/*/$*/}
                        <br className="framer-text" />
                        <strong className="framer-text">10.15.</strong> This
                        Agreement shall be governed by and construed in
                        accordance with the laws applicable to the Scallop Group
                        entity involved in the provision of the relevant
                        services, subject to mandatory consumer protection laws
                        applicable in the customer&rsquo;s country of residence.
                        <br className="framer-text" />
                        <strong className="framer-text">10.16.</strong> Nothing
                        in these Terms and Conditions shall deprive the customer
                        of mandatory consumer protection rights or
                        jurisdictional protections granted under applicable law.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-o841ji termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">10.1 </strong>Account
                        functionality. The customer acknowledges, understands
                        and accepts that Scallop will in no event, except for
                        the provision of Customer Support, assume any liability
                        for the functionality of the Account, including but not
                        limited to any of the functionalities referred to in the
                        foregoing.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">10.2</strong> Changes to
                        the Platform. Scallop may need to make changes, updates
                        and upgrades to the Platform as it sees fit from time to
                        time. In such a case, the customer will be notified in
                        advance.
                      </p>
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">10.3</strong>{' '}
                        Inactivity. If the customer&rsquo;s Platform Account is
                        inactive, meaning that no log-in has occurred for a
                        period longer than six (6) months, Scallop has the right
                        to terminate the Agreement with the customer and close
                        their Platform Account.
                        <br className="framer-text" />
                        <strong className="framer-text">10.4</strong>{' '}
                        Intellectual property rights. Upon entering into the
                        Agreement, Scallop grants their customers a limited,
                        non-exclusive, non-sublicensable, non-transferable,
                        revocable right to use the Platform. All the
                        intellectual property in the Platform are owned by us or
                        our licensors (such as our logo and designs, the content
                        on the Platform, all software and source code,
                        trademarks, know-how, and data related to the Platform).
                        The customer doesn&rsquo;t have any right to use our or
                        our licensors&rsquo; names, trademarks, logos or other
                        intellectual property. The customer must not copy,
                        reproduce, modify, reverse engineer or disassemble any
                        of our products, services or any intellectual property
                        rights.
                        <br className="framer-text" />
                        <strong className="framer-text">10.5</strong>{' '}
                        Performance analytics. To ensure that the services work
                        as intended and in order to provide our customers with
                        the best customer service possible, we conduct
                        performance analytics based on data shared with us. Our
                        customers should refer to our privacy policy if they
                        would like to know more about our processing of personal
                        data.
                        <br className="framer-text" />
                        <strong className="framer-text">10.6</strong>{' '}
                        Scallop&rsquo;s liability. The Platform is provided
                        &ldquo;as is&rdquo; and we cannot guarantee that the
                        Platform will be free from faults or interruptions. This
                        is partly due to the fact that we rely on some third
                        parties to provide the Platform.
                        <br className="framer-text" />
                        <strong className="framer-text">10.7</strong> Scallop is
                        not liable for any services provided by third parties to
                        our customers, and we do not undertake any
                        responsibility in relation thereto.
                        <br className="framer-text" />
                        <strong className="framer-text">10.8</strong>{' '}
                        Unauthorised payments. Users may be liable for
                        unauthorised transactions up to a maximum amount of
                        &euro;35 (or the equivalent amount under applicable law)
                        until a lost or stolen payment instrument is reported,
                        where applicable under mandatory law. Refunds, where
                        required by applicable law, are processed by the next
                        business day.
                        <br className="framer-text" />
                        <strong className="framer-text">10.9</strong> Exclusions
                        of liability. In addition to the above and to the extent
                        such limitation is permitted by law, Scallop will not be
                        responsible:
                      </p>
                      <ul dir="auto" className="framer-text termsandconditions-s36">
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any indirect, punitive or consequential damages
                            or losses including but not limited to loss of
                            profit, loss of data, loss of business, loss of
                            goodwill and loss of reputation;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any damages, losses or costs in connection with
                            or due to compliance with applicable laws,
                            regulations, orders and decisions of courts or
                            authorities or other regulatory requirements of
                            payment systems, card payment systems or any other
                            payment, clearing or settlement system;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any damages, losses or costs in connection with
                            or due to any delays, interruptions, faults or
                            inaccuracies relating to the Platform;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any damages, losses or costs caused by a virus,
                            malware, phishing or other technological attacks or
                            harmful material that may infect the customers IT
                            equipment and infrastructure being used for the
                            Platform;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any damages, losses or costs that arise in
                            connection with or due to unauthorised transactions;
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any damages, losses or costs arising in
                            connection with or due to third party&rsquo;s
                            decision (i) not to onboard you and open an Account
                            for the customer, (ii) close their Account, or (iii)
                            reject a transaction; or
                          </p>
                        </li>
                        <li data-preset-tag="p" className="framer-text">
                          <p className="framer-text">
                            for any fraudulent act conducted by any third party
                            contacting you posing to be representing for example
                            us, a well-known company or an acquaintance of a
                            natural person related to our customer asking them
                            to disclose their customer details such as password,
                            logins etc. Never we request that kind of
                            information or undertake any such action.
                          </p>
                        </li>
                      </ul>
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        <strong className="framer-text">10.10.</strong> Force
                        Majeure. We shall not be liable for any breach or delay
                        in the performance of our obligations under the
                        Agreement if such breach or delay is caused, directly or
                        indirectly, by fire, flood, earthquake, elements of
                        nature, wars (incl. cyberwar), civil or military
                        disturbances, acts of terrorism, sabotage, strikes,
                        riots, epidemic, pandemic, or any cause beyond our
                        reasonable control (&ldquo;force majeure event&rdquo;).
                        Should a force majeure event occur, the customer will be
                        notified thereof and Scallop will be excused from
                        performance of the obligations being affected for as
                        long as such force majeure event prevails.
                        <br className="framer-text" />
                        <strong className="framer-text">10.11.</strong>{' '}
                        Severability. If any of the provisions of the Agreement
                        is deemed invalid, unlawful or unenforceable, the
                        remaining provisions of the Agreement shall continue to
                        be valid and binding on the customer and us.
                        <br className="framer-text" />
                        <strong className="framer-text">10.12.</strong>{' '}
                        Assignment. The customer may not assign their rights or
                        obligations under the Agreement to a third party and
                        they are the sole party to the Agreement with us. The
                        customer is liable until the Platform Account is
                        terminated. Scallop may assign its rights or obligations
                        under the Agreement to a group company or to any third
                        party without your prior consent.
                        <br className="framer-text" />
                        <strong className="framer-text">10.13.</strong> No
                        waiver. Scallop has the right to exercise any right or
                        remedy it has under the Agreement at any time, even if
                        such exercise is delayed, or we previously failed to
                        exercise any right or remedy it is entitled to.
                        <br className="framer-text" />
                        <strong className="framer-text">10.14.</strong> Dispute
                        resolution. If the customer is dissatisfied with the
                        Platform or their Platform Account, they should contact
                        Customer Support in the first instance. To submit a
                        formal complaint, the customer must do so in writing,
                        providing the relevant circumstances and details of the
                        complaint. Where applicable, customers may have the
                        option to use alternative dispute resolution or consumer
                        protection mechanisms available in their jurisdiction.
                        For customers located in the European Union, this may
                        include the use of the European Union&rsquo;s online
                        dispute resolution platform available at {/*$*/}
                        <a className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="https://consumer-redress.ec.europa.eu/site-relocation_en?event=main.trader.register" target="_blank" rel="noopener">
                          <span className="framer-text termsandconditions-s39">
                            https://ec.europa.eu/consumers/odr/main/?event=main.trader.register
                          </span>
                        </a>
                        {/*/$*/}
                        <br className="framer-text" />
                        <strong className="framer-text">10.15.</strong> This
                        Agreement shall be governed by and construed in
                        accordance with the laws applicable to the Scallop Group
                        entity involved in the provision of the relevant
                        services, subject to mandatory consumer protection laws
                        applicable in the customer&rsquo;s country of residence.
                        <br className="framer-text" />
                        <strong className="framer-text">10.16.</strong> Nothing
                        in these Terms and Conditions shall deprive the customer
                        of mandatory consumer protection rights or
                        jurisdictional protections granted under applicable law.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-fk6pci termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s31">
                        11. Miscellaneous
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-fk6pci termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <h2 dir="auto" className="framer-text termsandconditions-s32">
                        11. Miscellaneous
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-lqq9n0 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        Invalid terms are replaced by valid ones fulfilling the
                        primary purpose. Changes or amendments must be in
                        writing.
                        <br className="framer-text" />
                        For further details, refer to the official Scallop
                        website or contact support.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-lqq9n0 termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        Invalid terms are replaced by valid ones fulfilling the
                        primary purpose. Changes or amendments must be in
                        writing.
                        <br className="framer-text" />
                        For further details, refer to the official Scallop
                        website or contact support.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1g04cjv">
                    <div className="framer-ntaehq termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s26">
                        Invalid terms are replaced by valid ones fulfilling the
                        primary purpose. Changes or amendments must be in
                        writing.
                        <br className="framer-text" />
                        For further details, refer to the official Scallop
                        website or contact support.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-166efju">
                    <div className="framer-ntaehq termsandconditions-s21 reveal" data-framer-name="Find quick answers about our services. Reach out to us directly for more information!" data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text termsandconditions-s36">
                        Invalid terms are replaced by valid ones fulfilling the
                        primary purpose. Changes or amendments must be in
                        writing.
                        <br className="framer-text" />
                        For further details, refer to the official Scallop
                        website or contact support.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-wqzll6 hidden-166efju" data-framer-name="Mobile">
            <div className="framer-1vwoh5c" data-framer-name="Frame 33595">
              <div className="framer-cx5tk">
                <div data-framer-component-type="SVG" data-framer-name="Logo" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-h5xjgn termsandconditions-s40" aria-hidden="true">
                  <div className="svgContainer termsandconditions-s41">
                    <svg viewBox="0 0 121 38" className="termsandconditions-s42">
                      <use href="#svg-1756771329_4687" />
                    </svg>
                  </div>
                </div>
                <div className="framer-spi2x3">
                  <div className="framer-9r4hjy termsandconditions-s21 reveal" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s43">
                      Be the first to experience the{' '}
                      <strong className="framer-text">
                        future of digital banking.
                      </strong>
                    </p>
                  </div>
                  <div className="framer-vii6th-container">
                    {/*$*/}
                    <a className="framer-9PalM framer-6q7a9y framer-v-4uzvf5 framer-12rwjxo termsandconditions-s44" data-border="true" data-framer-name="Primary / Small" data-highlight="true" href="https://www.scallopx.com/waitlist/" target="_blank" rel="noopener" tabIndex={0}>
                      <div className="framer-1bw53x4 termsandconditions-s45 reveal" data-framer-component-type="RichTextContainer">
                        <p className="framer-text termsandconditions-s16">
                          Join Waitlist
                        </p>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                </div>
              </div>
              <div className="framer-dv1byu" data-framer-name="Frame 33594">
                <div className="framer-xokqoy" data-framer-name="Menu">
                  <div className="framer-1p6mgvd termsandconditions-s21 reveal" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s46">
                      Laguage
                    </p>
                  </div>
                  <div className="framer-1aixlkn" data-framer-name="List">
                    {/*$*/}
                    <div className="framer-1gcm3sq-container">
                      {/*$*/}
                      <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/en-in">
                        <div className="framer-wlx7jb termsandconditions-s47 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                          <p className="framer-text termsandconditions-s48">
                            {/*$*/}
                            <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/en-in" data-nested-link="true" role="link" tabIndex={0}>
                              en-in
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                    {/*$*/}
                    <div className="framer-y4wt8n-container">
                      {/*$*/}
                      <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/old-home">
                        <div className="framer-wlx7jb termsandconditions-s47 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                          <p className="framer-text termsandconditions-s48">
                            {/*$*/}
                            <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/old-home" data-nested-link="true" role="link" tabIndex={0}>
                              en-eu
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                    {/*$*/}
                    <div className="framer-siti16-container">
                      {/*$*/}
                      <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/old-home">
                        <div className="framer-wlx7jb termsandconditions-s47 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                          <p className="framer-text termsandconditions-s48">
                            {/*$*/}
                            <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/old-home" data-nested-link="true" role="link" tabIndex={0}>
                              en-ch
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                  </div>
                </div>
                <div className="framer-6efb6d" data-framer-name="Menu">
                  <div className="framer-26j1wn termsandconditions-s21 reveal" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s46">
                      Features
                    </p>
                  </div>
                  <div className="framer-1k57860" data-framer-name="List">
                    {/*$*/}
                    <div className="framer-1lzpnzm-container">
                      {/*$*/}
                      <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="./old-home#accounts">
                        <div className="framer-wlx7jb termsandconditions-s47 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                          <p className="framer-text termsandconditions-s48">
                            {/*$*/}
                            <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="./old-home#accounts" data-nested-link="true" role="link" tabIndex={0}>
                              Accounts
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                    {/*$*/}
                    <div className="framer-1caod5c-container">
                      {/*$*/}
                      <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/cards">
                        <div className="framer-wlx7jb termsandconditions-s47 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                          <p className="framer-text termsandconditions-s48">
                            {/*$*/}
                            <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/cards" data-nested-link="true" role="link" tabIndex={0}>
                              Cards
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                    <div className="framer-zjyojc-container">
                      {/*$*/}
                      <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="https://emoney.io/">
                        <div className="framer-wlx7jb termsandconditions-s47 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                          <p className="framer-text termsandconditions-s48">
                            {/*$*/}
                            <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="https://emoney.io/" rel="noopener" data-nested-link="true" role="link" tabIndex={0}>
                              E Money Network
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                </div>
                <div className="framer-s5v5py" data-framer-name="Menu">
                  <div className="framer-jz9i1c termsandconditions-s21 reveal" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s46">
                      About
                    </p>
                  </div>
                  <div className="framer-1gt5s4j" data-framer-name="List">
                    {/*$*/}
                    <div className="framer-12ehw87-container">
                      {/*$*/}
                      <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="./old-home#faqs">
                        <div className="framer-wlx7jb termsandconditions-s47 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                          <p className="framer-text termsandconditions-s48">
                            {/*$*/}
                            <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="./old-home#faqs" data-nested-link="true" role="link" tabIndex={0}>
                              FAQs
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                    <div className="framer-8vau8o-container">
                      {/*$*/}
                      <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="https://x.com/emoney_network">
                        <div className="framer-wlx7jb termsandconditions-s47 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                          <p className="framer-text termsandconditions-s48">
                            {/*$*/}
                            <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="https://x.com/emoney_network" rel="noopener" data-nested-link="true" role="link" tabIndex={0}>
                              Community
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*$*/}
                    <div className="framer-gjoaqa-container">
                      {/*$*/}
                      <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/support">
                        <div className="framer-wlx7jb termsandconditions-s47 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                          <p className="framer-text termsandconditions-s48">
                            {/*$*/}
                            <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/support" data-nested-link="true" role="link" tabIndex={0}>
                              Contact Us
                            </span>
                            {/*/$*/}
                          </p>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                    {/*/$*/}
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1hrm2j6" data-framer-name="Frame 33831">
              <div className="framer-1md0gld" data-framer-name="Link">
                <div className="framer-11i76s0">
                  <div data-framer-component-type="SVG" data-framer-name="ic:baseline-copyright" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1gqc0t6 termsandconditions-s40" aria-hidden="true">
                    <div className="svgContainer termsandconditions-s41">
                      <svg viewBox="0 0 20 20" className="termsandconditions-s42">
                        <use href="#svg-1839680863_948" />
                      </svg>
                    </div>
                  </div>
                  <div className="framer-1rv13xz termsandconditions-s21 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s49">
                      2026 Scallop Group. All rights reserved
                    </p>
                  </div>
                </div>
                <div className="framer-15j95am">
                  <div className="framer-d5gyw0 termsandconditions-s21 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s50">
                      {/*$*/}
                      <a className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/privacypolicy">
                        Privacy Policy
                      </a>
                      {/*/$*/}
                    </p>
                  </div>
                  <div className="framer-10k8sba termsandconditions-s21 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s50">
                      |
                    </p>
                  </div>
                  <div className="framer-1suvffw termsandconditions-s21 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s50">
                      {/*$*/}
                      <a className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/marketingtermsandconditions">
                        Marketing Terms
                      </a>
                      {/*/$*/}
                    </p>
                  </div>
                </div>
                <div className="framer-10udfka">
                  <div className="framer-50hey2 termsandconditions-s21 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s50">
                      {/*$*/}
                      <a className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/termsandconditions" data-framer-page-link-current="true">
                        Terms &amp; Conditions
                      </a>
                      {/*/$*/}
                    </p>
                  </div>
                  <div className="framer-uip51g termsandconditions-s21 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s50">
                      |
                    </p>
                  </div>
                  <div className="framer-13l847g termsandconditions-s21 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                    <p dir="auto" className="framer-text termsandconditions-s50">
                      {/*$*/}
                      <a className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/refundpolicy">
                        Refund Policy
                      </a>
                      {/*/$*/}
                    </p>
                  </div>
                </div>
              </div>
              <div className="framer-1kq7bsq">
                {/*$*/}
                <a data-framer-component-type="SVG" as="a" data-framer-name="Frame 33830" href="https://x.com/emoney_network" target="_blank" rel="noopener" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1aaz7dj framer-1vuthme termsandconditions-s51" aria-hidden="true" />
                {/*/$*/}
                {/*$*/}
                <a data-framer-component-type="SVG" as="a" data-framer-name="Frame 33830" href="https://t.me/Emoney_io" target="_blank" rel="noopener" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-2fk870 framer-1vuthme termsandconditions-s52" aria-hidden="true" />
                {/*/$*/}
              </div>
            </div>
          </div>
          <div className="framer-1ouqo9z-container">
              <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                <div className="framer-1hodcae-container">
                   <Footer />
                </div>
              </div>
             
            </div>
        </div>
        <div id="overlay" />
        {/*/$*/}
      </>
    </div>;
}
export default TermsAndConditions;